import React, { memo, Suspense, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";

import { History } from "../../../../../../redux/services/Order/getHistory";
import { useAppContext } from "../../../../../../context";
import Mark from "../../Mark";

const TimeDifference: React.FC<TimeDifference.Props> = ({ change }) => {
	const { t } = useTranslation();
	const { dateFns } = useAppContext();

	const prevTime = useMemo(
		() =>
			`${dateFns.formatTime2(change.previous || 0, "HH:mm", {
				timezone: "UTC",
			})} ${t("units.minute") ?? "min"}`,
		[change.previous, dateFns, t],
	);

	const newTime = useMemo(
		() =>
			`${dateFns.formatTime2(change.actual || 0, "HH:mm", {
				timezone: "UTC",
			})} ${t("units.minute") ?? "min"}`,
		[change.actual, dateFns, t],
	);

	return (
		<Suspense>
			<Trans
				i18nKey={`change_history.orders.fields.${change.field}`}
				context={change.previous ? "change" : "set"}
				values={{
					prev: prevTime,
					new: newTime,
				}}
				components={{ mark: <Mark /> }}
			/>
		</Suspense>
	);
};

declare namespace TimeDifference {
	interface Props {
		change:
			| History.Field.WaitingTimeMilliseconds
			| History.Field.IdleTimeMilliseconds
			| History.Field.HourlyMilliseconds;
	}
}

export const TimeDifferenceMemo = memo(TimeDifference);
export default TimeDifference;
